import { SBaseDisplay } from '@summit/core';

import { EboObjectTimePeriod } from '../base-classes/ebo-object-time-period';
import { LinehaulRun } from './linehaul-run';
import { Route } from './route';

export class RouteLinehaulAssignment extends EboObjectTimePeriod implements SBaseDisplay {
  routeID: string;
  route: Route;
  linehaulRunID: string;
  linehaulRun: LinehaulRun;
  comment: string;

  constructor(jsonData?: Partial<RouteLinehaulAssignment>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.route) {
        this.route = new Route(jsonData.route);
      }
      if (jsonData.linehaulRun) {
        this.linehaulRun = new LinehaulRun(jsonData.linehaulRun);
      }
    }
  }

  toShortString(format: string = null): string {
    if (format == 'forRoute') {
      return `${this.linehaulRun ? this.linehaulRun.toShortString() : 'Unknown'}`;
    }
    if (format == 'RouteOnly') {
      return `${this.route ? this.route.name : 'Unknown'}`;
    }
    return `${this.route ? this.route.toShortString() : 'Unknown'}-${
      this.linehaulRun ? this.linehaulRun.toShortString() : 'Unknown'
    }`;
  }

  toTimeLineView(): string {
    return `${this.startTime.format('MM/DD/YY')} - ${this.endTime ? this.endTime.format('MM/DD/YY') : 'Current'}: ${
      this.route ? this.route.toShortString() : 'Unknown'
    }`;
  }
}
